import axiosInstance from '../components/axiosInstance';

export const getAllQuestionnaires = async () => {
  try {
    const response = await axiosInstance.get('/questionnaires/');
    return response.data;
  } catch (error) {
    console.error("Error fetching questionnaires", error);
    throw error;
  }
};